<template>
    <navigation />

    <promo-header>
        <h1>
          {{ $t("home.heading") }}
        </h1>
    </promo-header>

    <section class="section section-blue">

        <div class="container">

            <h2 class="mb-4 text-end">
                دروس اللغة العربية
            </h2>

            <arabic-assets-list v-if="$app.auth" />

            <p
                v-else
                class="mt-5 text-end"
            >
                <a href="/register" class="btn btn-main btn-outline-light me-3" :title="$t('auth.register')">
                    {{ $t('auth.register') }}
                </a>
                <a href="/login" class="btn btn-main btn-outline-light" :title="$t('auth.login')">
                    {{ $t('auth.login') }}
                </a>
            </p>

        </div>

    </section>


    <site-footer />
</template>

<script>
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import ArabicAssetsList from "../partials/arabic/ArabicAssetsList.vue";

export default {
    name: "About",

    components: {
        PromoHeader,
        Navigation,
        SiteFooter,
        ArabicAssetsList,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("arabic.lessonsInArabic")}`,
        };
    },
};
</script>
